<span *ngIf="!loading">
    <span class="mr-1" *ngFor="let star of starsArrays"  (click)="setStars(star.value, true)">
        <mat-icon [style]="'width: '+size+'px; height: '+size+'px; font-size: 1rem'" inline="true" *ngIf="star.typeStar === 'full'" svgIcon="star-full"></mat-icon>
        <mat-icon [style]="'width: '+size+'px; height: '+size+'px; font-size: 1rem'" inline="true" *ngIf=" star.typeStar === 'half'" svgIcon="star-half"></mat-icon>
        <mat-icon [style]="'width: '+size+'px; height: '+size+'px; font-size: 1rem'" inline="true" *ngIf=" star.typeStar === 'empty'" svgIcon="star-empty"></mat-icon>
    </span>
</span>
